<script lang="ts">
    import { getImageSizeUrl } from "@/utils/getImageSizeUrl";
    import ReviewsAverageRatingStars from "@apps/reviews/components/ReviewsAverageRatingStars/ReviewsAverageRatingStars.svelte";
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { createEventDispatcher } from "svelte";
    import { container } from "tsyringe";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Image from "@components/Image/Image.svelte";

    export let review: ReviewEntity;

    const dispatch = createEventDispatcher();

    const i18nModule = container.resolve(I18nModule);
    const t_anonym$ = i18nModule.exports.i18n.selectT(
        "reviews.ProductReviewsMiniSliderWidget",
        "anonym"
    );

    const handleOpenReview = (event: Event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch("openReview", review.uid);
    };

    $: customerName = review.customer?.name ?? $t_anonym$;
</script>

<div class="gw-rv-slider-item">
    <BaseButton
        ariaLabel={"Open review " + review.title}
        on:click={handleOpenReview}
    >
        <div class="gw-rv-slider-item__card">
            {#if review.images[0]}
                <div class="gw-rv-slider-item__image-wrapper">
                    <Image
                        wrapperClassName="gw-rv-slider-item__image-wrapper"
                        src={getImageSizeUrl(review.images[0].sizes, "xs") ||
                            ""}
                        objectFit="cover"
                        alt={review.title || "Review image"}
                        themeColor
                    />
                </div>
            {/if}

            <div class="gw-rv-slider-item__content">
                <div class="gw-rv-slider-item__header">
                    <span class="gw-rv-slider-item__review-author">
                        {customerName}
                    </span>

                    <div class="gw-rv-slider-item__rating">
                        <ReviewsAverageRatingStars
                            rating={review.rating}
                            starsSize={14}
                        />
                    </div>
                </div>
                <p class="gw-rv-slider-item__text">
                    {review.body}
                </p>
            </div>
        </div>
    </BaseButton>
</div>

<style lang="postcss">
    .gw-rv-slider-item {
        --slide-gap: 32px;
        display: flex;
        padding-right: var(--slide-gap);
        padding-left: var(--slide-gap);
        flex: 0 0 calc(100% - var(--slide-gap) * 2);

        &__card {
            display: flex;
            flex-wrap: nowrap;
            gap: 0.5em;
        }

        :global(&__image-wrapper) {
            width: 52px;
            height: 52px;
        }

        &__content {
            display: flex;
            align-items: start;
            flex-direction: column;
            overflow: hidden;
            row-gap: 4px;
        }

        &__header {
            display: flex;
            gap: 0.625em;
            overflow: hidden;
        }

        &__review-author {
            text-align: left;
            font-size: 14px;
            line-height: 16px;
            font-weight: 600;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
        }

        &__rating {
            display: flex;
            gap: 0.25;
            font-size: 0.8125em;
        }

        &__text {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 14px;
            line-height: 18px;
            margin: 0;
            text-align: left;
        }
    }
</style>
